import firebase from 'firebase/app';
import "firebase/firestore";

var firebaseConfig = {
    apiKey: "AIzaSyAn4dZIb7z3FhDr4HBdJbLN4d705GxI26M",
    authDomain: "relmenu.firebaseapp.com",
    projectId: "relmenu",
    storageBucket: "relmenu.appspot.com",
    messagingSenderId: "336571632903",
    appId: "1:336571632903:web:245a014b4e96354e6ec9a2",
    measurementId: "G-5M10JMG99L"
};

let firebaseApp = firebase.initializeApp(firebaseConfig);
let db = firebase.firestore();

export { db, firebase };